'use strict';

var RestrictedFilter = function RestrictedFilter() {
  return function (input) {
    return input === true ? 'Restricted' : input === undefined ? '' : 'Public';
  };
};
RestrictedFilter.$inject = [];
module.exports = RestrictedFilter;